import InfrastructureLayout from "./InfrastructureLayout";

export default InfrastructureLayout;